import { Box, Grid, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function FeatureShowcase() {
  return (
    <Box sx={{ py: 3, px: 2, textAlign: "center" }}>
      {/* TOP TEXT */}
      <Typography
        variant="overline"
        sx={{ color: "#f6521a", fontWeight: 700, letterSpacing: 1 }}
      >
        SMART POS FEATURES
      </Typography>

      <Typography variant="h3" sx={{ fontWeight: 700, mt: 1, mb: 2 }}>
        A smarter POS built to simplify <br /> your daily operations
      </Typography>

      <Typography
        variant="body1"
        sx={{
          maxWidth: 650,
          mx: "auto",
          color: "text.secondary",
          mb: 8,
          lineHeight: 1.7,
        }}
      >
        An intuitive and powerful restaurant POS designed to reduce manual
        effort, speed up billing, and help your team handle busy hours with
        ease.
      </Typography>

      {/* IMAGE + CONTENT SECTION */}
      <Grid container spacing={6} alignItems="center">
        {/* LEFT IMAGE */}
        <Grid item size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              width: "100%",
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            <img
              src="/img/home-banner.jpg"
              alt="POS UI"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: 12,
              }}
            />
          </Box>
        </Grid>

        {/* RIGHT CONTENT */}
        <Grid item size={{ xs: 12, md: 5 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Quick & effortless restaurant{" "}
            <span style={{ color: "#f6521a" }}>billing</span>
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              lineHeight: 1.7,
              mb: 3,
            }}
          >
            Generate bills in just a few taps. Split or merge orders, apply
            discounts, add modifiers, and print instantly — everything designed
            to work smoothly even during rush hours.
          </Typography>

          <Button
            variant="text"
            sx={{
              color: "#f6521a",
              fontWeight: 600,
              textTransform: "none",
            }}
            endIcon={<span style={{ marginLeft: 4 }}>→</span>}
            to="/pos/explore-all-features"
            component={RouterLink}
          >
            Explore all features
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
